<template lang="html">
    <div id="d-profile-page">

      <section class="short-info-section-s1">
        <div class="box-top">
          <div class="col-12 col-title">
            <h2 class="txt-breadcrumb">
              <span>Mi perfil</span>
              Información académica
            </h2>
          </div>
        </div>
      </section>

      <section class="main-section">
        <b-form class="form" @submit="onSubmit">
          <div class="row">

            <div class="col-lg-12">
              <b-form-group class="mb-4 form-group-s1"
                label="Formación académica">
                <b-form-textarea
                  v-model="$root.user.academic_training" disabled
                ></b-form-textarea>
              </b-form-group>
            </div>


            <div class="col-lg-12">
              <b-form-group class="mb-4 form-group-s1"
                label="Habilidades generales">
                <b-form-textarea
                  v-model="$root.user.general_skills" disabled
                ></b-form-textarea>
              </b-form-group>
            </div>

            <div class="col-lg-12">
              <b-form-group class="mb-4 form-group-s1"
                label="Habilidades generales (Idiomas)">
                <b-form-textarea
                  v-model="$root.user.general_skills_language" disabled
                ></b-form-textarea>
              </b-form-group>
            </div>

            <div class="col-lg-12">
              <b-form-group class="mb-4 form-group-s1"
                label="Habilidades generales(Conducir)">
                <b-form-textarea
                  v-model="$root.user.general_skills_drive" disabled
                ></b-form-textarea>
              </b-form-group>
            </div>


            <!-- <div class="col-12 mt-lg-4 text-center">
              <b-button type="submit" class="btn-s1 bg-red btn-lg btn-send">Guardar</b-button>
            </div> -->

          </div>
          <sweet-modal :icon="modal.icon" :blocking="modal.block" :hide-close-button="modal.block"  ref="modal">
          <div class="fa-3x" v-if="modal.icon== ''"><i class="fas fa-spinner fa-pulse"></i></div><br/>
          <div v-html="modal.msg"></div>

        </sweet-modal>
        </b-form>
      </section>

    </div>
  </template>

  <script>
  export default {
    data() {
      return {
        form: {
          name: null,
          lastname: null,
          email: null,
          state_id: null,
          town_id: null,
          num_ext: null,
          neighborhood:null,
          zipcode:null,
        },
        states:[],
        towns:[],
        modal:{
          msg:'',
          icon:'',
          block:false,
        },
      }
    },
    watch:{
      'form.state_id':function(){
            this.getTowns();
      }
    },

    methods: {
      onSubmit(event) {
        event.preventDefault();
        /*this.modal.block = true;
          this.modal.icon = '';
          this.modal.msg = 'Guardando informacion...';
          this.$refs.modal.open();

          axios.post(tools.url("/api/user/profile"), this.form).then((response)=>{
            this.modal.block = false;
              this.modal.icon = 'success';
              this.modal.msg = response.data.msg;
              this.$root.auth();
          }).catch((error)=>{
            this.modal.block = false;
              this.modal.icon= "error";
              this.modal.msg = error.response.data;

          });*/
      },

    },
    mounted(){

    }
  }
  </script>
